import React, { useState, useEffect } from "react";
import { FormControl, InputLabel, MenuItem, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { useTheme } from "@mui/material/styles";

export const ReactHookFormInput = ({
  type,
  id,
  name,
  control,
  error = false,
  label = "",
  placeholder = "--- SELECCIONE ---",
  disabled = false,
  readOnly = false,
  ...inputProps
}) => {
  const height = 44;
  const theme = useTheme();
  const [items, setItems] = useState([]);
  const [blocking, setBlocking] = useState(true);
  const defaultOption = { value: 0, label: placeholder, isDisabled: true };

  return (
    <div style={{marginTop : 3}}>
    <FormControl fullWidth>
      <Controller
        render={({
          field: { onChange, onBlur, value },
          fieldState: { error },
          formState,
        }) => (
          <TextField
            type={type}
            size="medium"
            error={!!error}
            onChange={(evt) => {
              if (inputProps.onChangeExternal) {
                inputProps.onChangeExternal(evt, onChange);
              } else {
                onChange(evt);
              }
            }}
            onBlur={(evt) => {
              try {
                if (typeof onBlur === 'function') {
                  onBlur(evt);
                }
              } finally {
                if (typeof inputProps.onBlurExternal === 'function') {
                  inputProps.onBlurExternal(evt);
                }
              }
            }}
            value={value ?? ''}
            fullWidth
            label={label}
            variant="outlined"
            multiline={inputProps.multiline || false}
            disabled={disabled}
            style={(inputProps.multiline ? {} : { height })}
            InputLabelProps={{
              style: {
                height
              },
            }}
            InputProps={{
              readOnly: readOnly,
            }}
            inputProps={{
              style: {
                height,
                padding: '0px 14px',
                margin: '0px 0px 0px 0px',
              },
          }}
          FormHelperTextProps={{ style: { fontSize: 9,paddingLeft : 0 }}}
          />
        )}
        control={control}
        name={name}
      />
      {error && <div className="invalid-feedback">{error.message}</div>}
    </FormControl>
    </div>
  );
};
